module.exports = "#define GLSLIFY 1\nvoid main()\t{\n\tgl_FragColor = vec4(1.);\n}"